import { formatBps, formatCents } from "../../utils/directorFormat";

const ReceivablesKpiGrid = ({ summary }) => {
  if (!summary) return null;
  const items = [
    {
      key: "contracted",
      label: "Valor contratado",
      value: formatCents(summary.contractedAmountCents),
      meta: "Base declarada no filtro",
      tone: "neutral",
    },
    {
      key: "received",
      label: "Efetivamente recebido",
      value: formatCents(summary.receivedAmountCents),
      meta: "Somente baixas confirmadas",
      tone: "positive",
    },
    {
      key: "percentage",
      label: "Percentual pago",
      value: formatBps(summary.receivedPctBps),
      meta: "Recebido ÷ contratado",
      tone: "inflow",
    },
    {
      key: "scheduled",
      label: "Ainda previsto",
      value: formatCents(summary.scheduledAmountCents),
      meta: "Parcelas abertas; não recebidas",
      tone: "attention",
    },
  ];
  return <section aria-label="Resumo de clientes e recebimentos" className="director-kpi-grid">
    {items.map((item) => <article
      className={`director-kpi director-kpi--${item.tone}`}
      key={item.key}
    >
      <span>{item.label}</span>
      <strong>{item.value}</strong>
      <small>{item.meta}</small>
    </article>)}
  </section>;
};

export default ReceivablesKpiGrid;
